import { ReportColumnConfig } from 'components/ReportGrid_New/types';
import { formatDateTime } from 'utils/helpers';

export const WORK_IN_PROGRESS_REPORT = "Work In Progress V3 Report";
export const WORK_IN_PROGRESS_REPORT_DESCRIPTION = "Displays the Work In Progress V3 report for the date range provided";
export const WORK_IN_PROGRESS_REPORT_TITLE = "workInProgress";

export const columns: ReportColumnConfig[] = [
  { name: 'repairerGroup', title: 'Repairer Group' },
  { name: 'repairerName', title: 'Repairer Name' },
  { name: 'activeWebId', title: 'ActiveWeb Id' },
  { name: 'schemeCode', title: 'Scheme Code' },
  { name: 'registration', title: 'Registration' },
  { name: 'claimReference', title: 'Claim Reference' },
  { name: 'status', title: 'Status' },
  { name: 'dtgCreated', title: 'Created Date', type: 'date' },
  { name: 'dtgOnsite', title: 'On Site Date', type: 'date' },
  { name: 'dtgAuthorised', title: 'Authorised Date', type: 'date' },
  { name: 'dtgPartsOrdered', title: 'Parts Ordered Date', type: 'date' },
  { name: 'dtgEstimatedCompletion', title: 'Estimated Completion Date', type: 'date' },
  { name: 'replacementVehicleModel', title: 'Replacement Vehicle' },
  {
    name: 'dtgReplacementVehicleKeysOut',
    title: 'Replacement Vehicle Keys Out Date',
    type: 'date'
  },
  {
    name: 'replacementVehicleKeysOut',
    title: 'Replacement Vehicle Keys Out',
  },
  { name: 'dtgLastDataUpdate', title: 'Last Data Updated', type: 'date' },
  { name: 'dtgLastStatusChange', title: 'Last Status Change', type: 'date' },
  { name: 'dtgLastActivity', title: 'Last Activity Date', type: 'date' },
  { name: 'lastActivityBy', title: 'Last Activity By' },
  { name: 'dtgLatestPdelay', title: 'Latest PDelay', type: 'date' },
  { name: 'statusAge', title: 'Status Age' },
  { name: 'dataAge', title: 'Data Age' },
  { name: 'lastActivityAge', title: 'Last Activity Age' },
];

export const reportHeaderTagLine = `Report produced on ${formatDateTime(new Date())}`;
